import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Music, Film, Globe2 } from 'lucide-react';
export function KoreanWave() {
  const reasons = [{
    icon: <Music className="w-5 h-5 md:w-6 md:h-6" data-id="element-132" />,
    stat: '+250M',
    title: 'Fans del K-Pop',
    desc: 'BTS, BLACKPINK, NewJeans impulsan la demanda mundial'
  }, {
    icon: <Film className="w-5 h-5 md:w-6 md:h-6" data-id="element-133" />,
    stat: '+150 países',
    title: 'Ven K-Dramas',
    desc: 'Squid Game, Crash Landing: motivación constante'
  }, {
    icon: <TrendingUp className="w-5 h-5 md:w-6 md:h-6" data-id="element-134" />,
    stat: '+86%',
    title: 'Crecimiento anual',
    desc: 'El coreano es el idioma de mayor demanda en LATAM'
  }, {
    icon: <Globe2 className="w-5 h-5 md:w-6 md:h-6" data-id="element-135" />,
    stat: '+77M',
    title: 'Hablantes globales',
    desc: 'Coreano como segundo idioma crece sin parar'
  }];
  return <section className="py-12 md:py-20 bg-gradient-to-br from-brand-950 via-brand-900 to-brand-950 text-white relative overflow-hidden" data-id="element-136">
      {/* Decorative Korean flag-inspired accents */}
      <div className="absolute top-10 right-10 w-20 h-20 md:w-32 md:h-32 rounded-full bg-accent-600/20 blur-2xl" data-id="element-137"></div>
      <div className="absolute bottom-10 left-10 w-20 h-20 md:w-32 md:h-32 rounded-full bg-blue-500/20 blur-2xl" data-id="element-138"></div>

      <div className="absolute top-1/2 -translate-y-1/2 left-2 md:left-8 text-brand-800/30 text-6xl md:text-9xl font-bold select-none pointer-events-none" data-id="element-139">
        한
      </div>
      <div className="absolute top-1/2 -translate-y-1/2 right-2 md:right-8 text-brand-800/30 text-6xl md:text-9xl font-bold select-none pointer-events-none" data-id="element-140">
        류
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-141">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-14" data-id="element-142">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 rounded-full bg-accent-500/20 text-accent-400 font-bold mb-3 md:mb-5 border border-accent-500/30 text-xs md:text-sm" data-id="element-143">
            <span data-id="element-144">🇰🇷</span>
            <span className="uppercase tracking-wider" data-id="element-145">
              Hallyu · La Ola Coreana
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold mb-3 md:mb-5 leading-tight" data-id="element-146">
            El coreano nunca tuvo{' '}
            <span className="text-accent-400" data-id="element-147">tanta demanda</span>
          </h2>
          <p className="text-sm md:text-lg text-brand-300 font-medium px-2" data-id="element-148">
            Tus alumnos están más motivados que nunca. La pregunta es: ¿estás
            listo para enseñarles como un{' '}
            <span className="text-white font-bold" data-id="element-149">profe pro</span>?
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 max-w-5xl mx-auto" data-id="element-150">
          {reasons.map((r, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="bg-brand-900/60 backdrop-blur-sm border border-brand-700 rounded-xl md:rounded-2xl p-4 md:p-6 text-center hover:border-accent-500/50 transition-colors" data-id="element-151">
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-accent-500/10 text-accent-400 mb-2 md:mb-3 border border-accent-500/20" data-id="element-152">
                {r.icon}
              </div>
              <div className="text-xl md:text-3xl font-extrabold text-white mb-1" data-id="element-153">
                {r.stat}
              </div>
              <div className="text-xs md:text-sm font-bold text-accent-300 mb-1 md:mb-2" data-id="element-154">
                {r.title}
              </div>
              <p className="text-[11px] md:text-xs text-brand-400 leading-snug" data-id="element-155">
                {r.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center mt-8 md:mt-12" data-id="element-156">
          <p className="text-base md:text-xl text-brand-200 font-medium italic max-w-2xl mx-auto" data-id="element-157">
            "안녕하세요 선생님" — Tus alumnos lo dicen cada clase.
            <span className="block text-sm md:text-base text-brand-400 mt-1 not-italic" data-id="element-158">
              Tu trabajo es darles una experiencia que esté a la altura.
            </span>
          </p>
        </div>
      </div>
    </section>;
}